<template>
	<AppLayout title="Acceder">
		<div class="grow flex flex-col items-center sm:justify-center">
			<img class="m-6 w-25 hidden dark:inline-block" :src="storage('/logos/SVG/white/logo.svg')" alt="Logo AArEII">
			<img class="m-6 w-25 dark:hidden" :src="storage('/logos/SVG/logo.svg')" alt="Logo AArEII">
			<div class="p-8 flex flex-col gap-8 w-full sm:w-96">
				<form class="flex flex-col items-center md:items-stretch gap-5" @submit.prevent="login">
					<LabeledObject full>
						<template #label>Dirección de correo electrónico</template>
						<input v-model="credentials.email" type="email" required autocomplete="email" autofocus>
					</LabeledObject>
					<LabeledObject full>
						<template #label>Contraseña</template>
						<input v-model="credentials.password" type="password" required autocomplete="password">
					</LabeledObject>
					<div class="flex flex-col md:flex-row items-center md:justify-between gap-5">
						<Switch v-model="credentials.remember" label="Recordarme"/>
						<PrimaryButton :type="ButtonType.Submit" :color="Color.TrueAArEII">
							<i class="fa-solid fa-key mr-2"/>
							Acceder
						</PrimaryButton>
					</div>
					<Link :href="route('password.request')" class="text-center text-aareii-700 hover:underline hover:text-aareii-900">¿Olvidaste tu contraseña?</Link>
					<Link :href="route('register')" class="text-center text-aareii-700 hover:underline hover:text-aareii-900 text-sm">¿No tenés una cuenta? Registrate acá.</Link>
				</form>
			</div>
		</div>
	</AppLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {ref, type Ref} from 'vue'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {Link, router} from '@inertiajs/vue3'
import AppLayout from '@/Layouts/AppLayout.vue'
import {ButtonType} from '@/Types/Enums/ButtonType'
import Switch from '@/Components/Switch/Switch.vue'
import {type Credentials} from '@/Types/Credentials'
import LabeledObject from '@/Components/LabeledObject.vue'
import PrimaryButton from '@/Components/Buttons/PrimaryButton.vue'
import {type LoginResponse} from '@/Types/Responses/Auth/LoginResponse'
import {showInfo, showSuccess, showValidationErrors, storage} from '@/helpers'

const working:Ref<boolean> = ref(false)
const credentials:Ref<Credentials> = ref({
	email: '',
	password: '',
	remember: false,
})

function login(){
	if(!working.value){
		working.value = true
		showInfo(trans('general.logging_in'))
		axios.post(route('login'), credentials.value).then(({data}:LoginResponse) => {
			showSuccess(trans('general.logged_in'))
			router.get(data)
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>